import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import Image from "components/ui/image"
import { IS_NA, IS_US, IS_JEWLR } from "helpers/application"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"
import { cn } from "styles/utils"

const PaymentMethodImg = ({ className, isFooter, ...props }) => (
  <Image
    className={cn(
      "desktop:w-auto h-auto w-full",
      isFooter ? "desktop:h-32" : "desktop:h-20 max-h-24",
      className
    )}
    height="24"
    width="34"
    {...props}
  />
)

PaymentMethodImg.propTypes = {
  className: PropTypes.string,
  isFooter: PropTypes.bool,
}

const getPaymentMethods = ({ canProcessApplePay, canProcessGooglePay }) => [
  {
    alt: "Visa",
    src: require("images/cart/visa.svg"),
  },
  {
    alt: "Mastercard",
    src: require("images/cart/mastercard.svg"),
  },
  {
    alt: "American Express",
    show: IS_NA(),
    src: require("images/cart/amex.svg"),
  },
  {
    alt: "Discover",
    show: IS_US(),
    src: require("images/cart/discover.svg"),
  },
  {
    alt: "Affirm",
    show: IS_JEWLR() && sl.config.enable_affirm,
    src: require("images/cart/affirm.svg"),
  },
  {
    alt: "Klarna",
    show: IS_JEWLR() && enableKlarnaCheckout(),
    src: require("images/cart/klarna.svg"),
  },
  {
    alt: "PayPal",
    show: IS_JEWLR() && sl.config.enable_paypal,
    src: require("images/cart/paypal.svg"),
  },
  {
    alt: "Apple Pay",
    show:
      IS_JEWLR() &&
      sl.config.enable_apple_google_pay &&
      Boolean(canProcessApplePay),
    src: require("images/cart/apple-pay.svg"),
  },
  {
    alt: "Google Pay",
    show:
      IS_JEWLR() &&
      sl.config.enable_apple_google_pay &&
      Boolean(canProcessGooglePay),
    src: require("images/cart/google-pay.svg"),
  },
]

const AcceptPayments = ({ isFooter }) => {
  const canProcessApplePay = useSelector(
    (state) => state.cartUI.canProcessApplePay
  )
  const canProcessGooglePay = useSelector(
    (state) => state.cartUI.canProcessGooglePay
  )

  const paymentMethods = getPaymentMethods({
    canProcessApplePay,
    canProcessGooglePay,
  })

  return (
    <section
      aria-label="Accepted Payment Methods"
      className={cn("mt-16", isFooter && "tablet:mb-20 tablet:py-10 my-12")}
    >
      <ul
        className={cn(
          "flex list-none flex-nowrap items-center justify-center gap-4",
          isFooter && "tablet:gap-6"
        )}
      >
        {paymentMethods
          .filter(({ show }) => show !== false)
          .map(({ alt, src }) => (
            <li key={alt}>
              <PaymentMethodImg alt={alt} isFooter={isFooter} src={src} />
            </li>
          ))}
      </ul>
    </section>
  )
}

AcceptPayments.propTypes = {
  isFooter: PropTypes.bool,
}

export default AcceptPayments
